export class IMonthEnergyCalculator {
  calcEnergy(energyData, contextData, month) {
    this.energyData = energyData;
    this.contextData = contextData;
    this.month = month;
  }
}
